let width = $(window).width();

if (width < 1200) {
  $(".btn-settings").click(function (e) {
    e.stopPropagation();
    $(".main-wrapper").fadeToggle();
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".nav-top").length) {
      $(".main-wrapper").fadeOut();
    }
  });

  $(".hamburger").click(function (e) {
    $(".main-wrapper").fadeOut();
  });
}
